import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { SectionHeading } from '../ui/Panels';
import { chefs } from '../../data/chefs';
import { menuQualifier } from '../../utils/pricing';
import { currency } from '../../utils/format';
import { useLocale } from '../../contexts/LocaleContext';
import { riseItem, staggerContainer, viewportOnce } from '../../utils/motion';
import { cn } from '../../utils/cn';
const picks = [{
  chefId: 'chef-elena',
  menuId: 'menu-elena-sunday'
}, {
  chefId: 'chef-kenji',
  menuId: 'menu-kenji-omakase'
}, {
  chefId: 'chef-amara',
  menuId: 'menu-amara-party'
}];
export function SignatureShowcase() {
  const reduce = useReducedMotion();
  const {
    locale,
    currencyCode
  } = useLocale();
  const entries = picks.map(({
    chefId,
    menuId
  }) => {
    const chef = chefs.find(c => c.id === chefId);
    const menu = chef?.menus.find(m => m.id === menuId);
    return chef && menu ? {
      chef,
      menu
    } : null;
  }).filter((entry): entry is {
    chef: (typeof chefs)[number];
    menu: (typeof chefs)[number]['menus'][number];
  } => Boolean(entry));
  return <section aria-labelledby="signature-heading" className="mx-auto max-w-shell px-5 pb-20 lg:px-8 lg:pb-24" data-id="element-627" data-mp="lbzkpw17mjsg">
      <SectionHeading level={2} title="Signature menus, written by the chef" hint="Not categories — the actual thing each chef thinks they do better than anyone." data-id="element-628" data-mp="104tdgj5hswf2" />
      <motion.ul variants={staggerContainer(0.07)} initial="hidden" whileInView="show" viewport={viewportOnce} className="mt-9 grid gap-5 lg:grid-cols-3" data-id="element-629" data-mp="7g5mq81z5eu4">
        {entries.map(({
        chef,
        menu
      }, index) => <motion.li key={menu.id} variants={riseItem(reduce, 20)} className={cn('flex flex-col overflow-hidden rounded-2xl border border-hairline bg-surface', index === 0 && 'lg:row-span-2')} data-id="element-630" data-mp="cgjudoznymrm" data-mpi={index}>
            <img src={menu.image} alt={menu.courses[0].description} className={cn('w-full object-cover', index === 0 ? 'aspect-[4/3]' : 'aspect-[16/9]')} loading="lazy" data-id="element-631" data-mp="9hutc0o3vnx7" />
            <div className="flex flex-1 flex-col p-5" data-id="element-632" data-mp="ia54plaqlzg1">
              <p className="text-[12px] font-semibold uppercase tracking-[0.05em] text-ink-3" data-id="element-633" data-mp="n8pvku43n6rt">{chef.name}</p>
              <h3 className="mt-1.5 font-display text-xl font-semibold tracking-[-0.01em] text-ink" data-id="element-634" data-mp="3momufragkjnb">{menu.name}</h3>
              <p className="mt-1.5 text-sm text-ink-2" data-id="element-635" data-mp="3qpydtf2qo8n2">{menu.tagline}</p>
              {index === 0 && <ol className="mt-4 space-y-2 border-t border-hairline pt-4" data-id="element-636" data-mp="3vmorxwuzgu5u">
                  {menu.courses.map(course => <li key={course.name} className="text-sm" data-id="element-637" data-mp="4fm1j7myyrwo">
                      <span className="font-medium text-ink" data-id="element-638" data-mp="1axiumzg0puqn">{course.name} — </span>
                      <span className="text-ink-2" data-id="element-639" data-mp="1fw2fewivl0hf">{course.description}</span>
                    </li>)}
                </ol>}
              <div className="mt-auto flex items-end justify-between gap-3 pt-5" data-id="element-640" data-mp="2vg32mcatnlwg">
                <p data-id="element-641" data-mp="2vifk6oco3u8z">
                  <span className="tnum font-display text-lg font-semibold text-ink" data-id="element-642" data-mp="2qp381dp6dfx4">
                    {currency(menu.pricePerGuest, locale, currencyCode)}
                  </span>
                  <span className="text-[13px] text-ink-2" data-id="element-643" data-mp="2lofh0s0y4z2w"> / guest</span>
                  <span className="mt-0.5 block text-[12px] text-ink-3" data-id="element-644" data-mp="2hpzo67i6owhk">{menuQualifier(menu)}</span>
                </p>
                <Link to={`/chefs/${chef.slug}`} className="shrink-0 text-sm font-medium text-primary underline decoration-primary/30 underline-offset-4 hover:decoration-primary" data-id="element-645" data-mp="2cry7ft88d999">
                  See the menu
                </Link>
              </div>
            </div>
          </motion.li>)}
      </motion.ul>
    </section>;
}